import { MessageBox } from 'element-ui';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';

export default {
  alert(message, title) {
    title = title ? title : '提示';
    return MessageBox.alert(message, title, {
      dangerouslyUseHTMLString: true,
    });
  },
  confirm(message, title, type) {
    title = title ? title : '提示';
    return MessageBox.confirm(message, title, {
      dangerouslyUseHTMLString: true,
      type:type ? type : 'warning',
    });
  },
  loading(text) {
    this.loadingBox = Loading.service({
      lock: true,
      text,
      customClass: 'loading-wrapper',
      background: 'rgba(255, 255, 255, 0.9)',
    });
  },
	error(message) {
		Message.error({
			dangerouslyUseHTMLString: true,
			message,
		});
	},
	success(message) {
		Message.success({
			dangerouslyUseHTMLString: true,
			message,
      showClose: true,
      duration:1000,
		});
	},
	warning(message) {
		Message.warning({
			dangerouslyUseHTMLString: true,
			message,
      showClose: true,
      duration:1000,
		});
	},
  close() {
    if (this.loadingBox) {
      this.loadingBox.close();
      this.loadingBox = null;
    }
  },
  info(message,duration,title){
    title = title ? title : '重要通知';
    Message.warning({
      dangerouslyUseHTMLString: true,
      center: true,
      message,
      duration,
      showClose:true,
      type: 'warning',
      offset: 100,
      customClass: 'winClass',
    });
  },
}



// WEBPACK FOOTER //
// ./src/utils/dialog.js